import {defineStore} from "pinia";
import {Ref, ref} from "vue";
import {ITableHeader, ITableItem} from "@/types/table";
import {IFilter} from "@/types/main";
import {DateTime} from "luxon";
import {savedMessagesService} from "@/features/saved/saved.service";
import {ISavedMessage} from "@/features/saved/saved.types";

export const useSavedMessagesStore = defineStore("savedMessages", () => {
    const headers: ITableHeader[] = [
        {
            name: "id",
            label: "No",
            width: '50px'
        },
        {
            name: "sender_name",
            label: "Sender",
            width: '150px'
        },
        {
            name: "receiver_name",
            label: "Receiver",
            width: '150px'
        },
        {
            name: "session_name",
            label: "Account",
            width: '150px'
        },
        {
            name: "shift_name",
            label: "Shift",
        },
        {
            name: "activity_time",
            label: "Date",
        },
        {
            name: "reply_time_seconds",
            label: "Reply time",
        },
        {
            name: "from",
            label: "From",
        },
        {
            name: "text",
            label: "Message",
            width: '600px'
        },
        {
            name: "save",
            label: "Save",
        },
    ];

    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)

    const commonFilter = ref<IFilter>({
        q: '',
        date_from: '',
        date_to: '',
        time_from: '',
        time_to: '',
        shift_id: 0,
        account: 0,
        outgoing: null,
        fuzzy: true,
        fuzzy_threshold: 0.3,
        page: 1,
        page_size: 50,
        include_photo_base64: false
    })

    async function getSavedMessages(loading: Ref) {
        try {
            loading.value = true
            let newFilter = {...commonFilter.value};
            if (newFilter.q.length == 0) {
                delete newFilter.fuzzy
                delete newFilter.fuzzy_threshold
            }
            const {data} = await savedMessagesService.getSavedMessages(newFilter);
            return data
        } finally {
            loading.value = false
        }
    }

    async function updateSavedMessage(loading: Ref, payload: ISavedMessage) {
        try {
            loading.value = true
            const {data} = await savedMessagesService.updateSavedMessage(payload);
            return data
        } finally {
            loading.value = false
        }
    }

    function datepickerToUtcDateOnly(d: Date | null | undefined) {
        if (!d) return ''
        const local = DateTime.fromJSDate(d)
        return DateTime.utc(local.year, local.month, local.day).toFormat('yyyy-MM-dd')
    }

    return {headers, commonFilter, getSavedMessages, updateSavedMessage};
});
